import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie-service";

@Injectable({ providedIn: "root" })
export class LanguageService {
  public languages: string[] = ["en", "es", "de", "it", "ru", "pt-br"];

  constructor(
    public translate: TranslateService,
    private cookieService: CookieService
  ) {
    let browserLang;
    this.translate.addLangs(this.languages);
    if (this.cookieService.check("lang")) {
      browserLang =
        this.cookieService.get("lang") == "pt"
          ? "pt-br"
          : this.cookieService.get("lang");
      this.cookieService.set("lang", browserLang);
    } else {
      this.setLanguage("pt-br");
      browserLang = translate.getBrowserLang();
    }
    translate.use(
      browserLang.match(/en|es|de|it|ru|pt-br/) ? browserLang : "en"
    );
  }

  public setLanguage(lang) {
    this.translate.use(lang);
    this.cookieService.set("lang", lang);
  }
}
